import {defineMessages} from 'react-intl'

/**
 * Strings for the navbar search (lead and contact flavours, desktop and the
 * mobile modal). Kept in one catalog because the desktop and mobile entry
 * points render the same placeholders and empty states.
 */
export const SEARCH_MESSAGES = defineMessages({
  // Accessible names. The template shipped these as Bootstrap's placeholder
  // copy ("Example text with button addon"), which said nothing to a screen
  // reader; they now name the actual control.
  ariaSearchLeads: {id: 'shell.search.aria.leads', defaultMessage: 'Search leads'},
  ariaSearchContacts: {id: 'shell.search.aria.contacts', defaultMessage: 'Search contacts'},

  // Placeholders
  leadPlaceholder: {
    id: 'shell.search.placeholder.lead',
    defaultMessage: 'Lead name or phone number',
  },
  leadPlaceholderLong: {
    id: 'shell.search.placeholder.leadLong',
    defaultMessage: 'Enter Lead name or phone number',
  },
  contactPlaceholder: {
    id: 'shell.search.placeholder.contact',
    defaultMessage: 'Contact name, phone number or last 4 digits of SSN',
  },
  contactPlaceholderLong: {
    id: 'shell.search.placeholder.contactLong',
    defaultMessage: 'Enter Contact name, phone number or last 4 digits of SSN',
  },

  // Empty states
  leadHint: {
    id: 'shell.search.hint.lead',
    defaultMessage: 'You can find your Leads by entering phone number or name',
  },

  errorWithMessage: {id: 'common.error.withMessage', defaultMessage: 'Error: {message}'},
})

